// --
import React from 'react';
import {localUTCToDate, dateToDateTimeString} from './../utils/commons';
import {Alert} from "reactstrap";
import * as StavZtotozneniZr from "./../api/gen/proxioapi/StavZtotozneniZr";
import DetailLeftIcon from "../detail/DetailLeftIcon";
import Icon from "../icon/FAIcon";
import * as form from "./../form";

/**
 * Komponenta pro zobrazení stavu subjektu vůči ZR.
 */
export default class SubjektStavZr extends React.Component {
    static PropTypes = {
        subjekt: React.PropTypes.object.isRequired,  // subjekt
    };

    render() {
        const {className, subjekt} = this.props;

        let color;
        let icon;
        let infos = [];
        let title;

        if (subjekt.vazbaZr && subjekt.stavZr) {
            switch (subjekt.stavZr.stavZtotozneni) {
                case StavZtotozneniZr.ZTOTOZNEN:
                    icon = "check";
                    title = "Ztotožněn vůči základním registrům";
                    color = "success";
                    break;
                case StavZtotozneniZr.NEZTOTOZNEN:
                    icon = "exclamation-triangle";
                    title = "Neztotožněn vůči základním registrům";
                    color = "warning";
                    if (subjekt.stavZr.duvodNeztotozneni) {
                        infos.push(<form.FieldGrid label="Důvod neztotožnění">{subjekt.stavZr.duvodNeztotozneni}</form.FieldGrid>);
                    }
                    break;
                case StavZtotozneniZr.POZASTAVEN:
                    icon = "pause";
                    title = "Pozastaveno vůči základním registrům";
                    color = "info";
                    break;
                case StavZtotozneniZr.CHYBA:
                    icon = "remove";
                    title = "Chyba při ztotožnění vůči základním registrům";
                    color = "error";
                    break;
            }

            // Důvod neztotožnění
            switch (subjekt.stavZr.stavZtotozneni) {
                case StavZtotozneniZr.ZTOTOZNEN:
                case StavZtotozneniZr.POZASTAVEN:
                case StavZtotozneniZr.CHYBA:
                    if (subjekt.stavZr.zpochybneneUdaje) {
                        color = "warning";
                        infos.push(<form.FieldGrid label="Zpochybněné údaje">{subjekt.stavZr.zpochybneneUdaje}</form.FieldGrid>);
                    }
                    break;
            }

            // Notifikace
            if (subjekt.stavZr.notifikaceOd && subjekt.stavZr.notifikaceDo) {
                infos.push(<form.FieldGrid label="Notifikace">{dateToDateTimeString(localUTCToDate(subjekt.stavZr.notifikaceOd))} - {dateToDateTimeString(localUTCToDate(subjekt.stavZr.notifikaceDo))}</form.FieldGrid>);
            } else {
                if (subjekt.stavZr.notifikaceOd) {
                    infos.push(<form.FieldGrid label="Notifikace od">{dateToDateTimeString(localUTCToDate(subjekt.stavZr.notifikaceOd))}</form.FieldGrid>);
                }
                if (subjekt.stavZr.notifikaceDo) {
                    infos.push(<form.FieldGrid label="Notifikace od">{dateToDateTimeString(localUTCToDate(subjekt.stavZr.notifikaceDo))}</form.FieldGrid>);
                }
            }

            // Datum aktualizace a posledního ověření změny
            if (subjekt.stavZr.stavZtotozneni !== StavZtotozneniZr.NEZTOTOZNEN) {
                const posleniOvereniZmeny = localUTCToDate(subjekt.stavZr.posleniOvereniZmeny);
                const posleniAktualizace = localUTCToDate(subjekt.stavZr.posleniAktualizace);
                if (+posleniOvereniZmeny === +posleniAktualizace) {   // stejné datumy, zobrazíme jen jeden text
                    infos.push(<form.FieldGrid
                        label="Ověřen v základních registrech">{dateToDateTimeString(posleniOvereniZmeny)}</form.FieldGrid>);
                } else {    // zobrazíme oba a s jiným textem
                    infos.push(<form.FieldGrid
                        label="Poslední aktualizace ze základních registrů">{dateToDateTimeString(posleniAktualizace)}</form.FieldGrid>);
                    infos.push(<form.FieldGrid
                        label="Poslední ověření změny">{dateToDateTimeString(posleniOvereniZmeny)}</form.FieldGrid>);
                }
            }
        } else {
            icon = "minus";
            title = "Subjekt je bez vazby na ZR"
            color = "info";
        }

        return <div className={className}>
            <Alert className={infos.length > 0 ? "mb-2" : ""} color={color}>
                <DetailLeftIcon icon={<Icon icon={icon}/>}>
                    {title}
                </DetailLeftIcon>
            </Alert>
            {infos}
        </div>
    }
}
